export enum RepeatableStates {
  RepeatableActivated = 'repeatable_activated',
  RepeatableDisabled = 'repeatable_disabled',
}
